export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const REFRESH_TOKEN = "refreshToken";
export const LOGIN_ECP = "loginEcp";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const UPDATE_USER_ROLE = "updateUserRole";
export const GET_USER_ROLE = "getUserRole";
export const OAUTH = "oauth";
export const FETCH_MP = "fetchMP";
export const FETCH_NEWS = "fetchNews";
export const FETCH_NEWS_ITEM = "fetchNewsItem";
export const FETCH_METHODS = "fetchMethods";
export const FETCH_TARIFFS = "fetchTariffs";
export const FETCH_TARIFFS_ARCHIVE = "fetchTariffsArchive";
export const UPDATE_AVATAR = "updateAvatar";
export const UPDATE_USER_ORG = "updateUserOrg";
